const defaultFormProps = {
    reValidateMode: 'onBlur',
    mode: 'onSubmit',
    criteriaMode: 'all'
};
export { defaultFormProps };
